export default __webpack_public_path__ + "static/media/mobileZoomedNet.05102ddb.PNG";